import { connect } from "react-redux"
import { compose } from "redux"
import { matchPath, withRouter } from "react-router"
import AppBar from "./AppBar"
import { setDrawerIsOpen } from "store/actions/reduxActions"
import * as actionTypes from "store/actions/types"
import request from "superagent"
import api from "../../constants/api"

const DEFAULT_TITLE = "GCS | Monitor"

// Special constants used in the wind stow table
const getSafetyStowDirection = (state, props) => {
	const { pathname } = props.location
	const rtnMatchPath = matchPath(pathname, { path: "/layout/:layoutId" })
	if (!rtnMatchPath) return ""
	const layoutId = rtnMatchPath.params.layoutId
	if (!layoutId) return ""
	const layoutDetails = state.layoutDetails[layoutId]
	if (!layoutDetails) return ""
	const stowMode = layoutDetails.safetyStowDirection
	if (stowMode === undefined || stowMode === null) return "Unknown Stow System"
	return stowMode ? "East Stowing System" : "West Stowing System"
}

const getBarTitle = (state, props) => {
	const { pathname } = props.location
	let title = ""
	let rtnMatchPath = matchPath(pathname, { path: "/layout/:layoutId" })
	if (rtnMatchPath !== null) {
		if (Object.prototype.hasOwnProperty.call(state.layoutDetails, rtnMatchPath.params.layoutId)) {
			title = state.layoutDetails[rtnMatchPath.params.layoutId]["name"]
		} else {
			title = ""
		}
		document.title = `${title}: ${DEFAULT_TITLE}`
	}
	if ((rtnMatchPath = matchPath(pathname, { path: "/layouts" })) !== null) {
		title = "Layouts"
		document.title = `${title}: ${DEFAULT_TITLE}`
	} else if ((rtnMatchPath = matchPath(pathname, { path: "/device-manager" })) !== null) {
		title = "Device Manager"
		document.title = `${title}: ${DEFAULT_TITLE}`
	} else if ((rtnMatchPath = matchPath(pathname, { path: "/users-list" })) !== null) {
		title = "User Manager"
		document.title = `${title}: ${DEFAULT_TITLE}`
	} else if ((rtnMatchPath = matchPath(pathname, { path: "/configure-layout/:layoutId" })) !== null) {
		if (Object.prototype.hasOwnProperty.call(state.layoutDetails, rtnMatchPath.params.layoutId)) {
			title = "Layout Configuration - " + state.layoutDetails[rtnMatchPath.params.layoutId]["name"]
		} else {
			title = "Layout Configuration"
		}
		document.title = `${title}: ${DEFAULT_TITLE}`
	}
	return title
}

const searchAvailable = (props) => {
	const { pathname } = props.location
	return matchPath(pathname, { path: "/layout/:layoutId" }) !== null
}

const chartAvailable = (props) => {
	const { pathname } = props.location
	return matchPath(pathname, { path: "/layout/:layoutId" }) !== null
}

const downloadAvailable = (props) => {
	// TODO design a permission/check to see if download is available
	const { pathname } = props.location
	return matchPath(pathname, { path: "/layout/:layoutId" }) !== null
}

function getSiteUuid(props) {
	return props.location.pathname.split("/")[2]
}
// New implementation: fetch pre-built GeniusHub configuration from REST API and download
const downloadGeniusFileFromApi = async (state, props) => {
	try {
		const uuid = getSiteUuid(props)
		const response = await api._sendRequest(`/sites/${uuid}/export-genius/`, "GET")
		if (!response || response.status !== 200) {
			alert(response?.text || "Failed to export GeniusHub configuration.")
			return
		}
		const content = response.body ?? (response.text ? JSON.parse(response.text) : null)
		if (!content) {
			alert("Failed to export Genius file configuration.")
			return
		}
		// Any "#" in a URI will be read as demarcating the URI fragment, so it must be replaced with "%23"
		const jsonData =
			"data:text;charset=utf-8," + JSON.stringify(content, null, 4).replaceAll("#", encodeURIComponent("#"))
		const encodedUri = encodeURI(jsonData)
		const link = document.createElement("a")
		const siteName = state.layoutDetails[uuid]?.name || "site"
		link.setAttribute("href", encodedUri)
		link.setAttribute("download", `${siteName}.genius`)
		document.body.appendChild(link)
		link.click()
		document.body.removeChild(link)
	} catch (e) {
		console.error(e)
		alert("Failed to export GeniusHub configuration.")
	}
}

// noinspection JSUnusedGlobalSymbols
const mapStateToProps = (state, props) => ({
	title: getBarTitle(state, props),
	safetyStowDirection: getSafetyStowDirection(state, props),
	drawerIsOpen: state.drawerIsOpen,
	searchAvailable: searchAvailable(props),
	chartAvailable: chartAvailable(props),
	downloadAvailable: downloadAvailable(props),
	userPrivileges: (state.user || {}).privileges,
	handleGeniusHubDownload: () => {
		// Use backend endpoint to generate and download the configuration
		downloadGeniusFileFromApi(state, props).then()
	},
})

const openSearch = (props) => {
	const params = new URLSearchParams(props.location.search)
	params.set("search", true)
	props.history.push({
		pathname: props.location.pathname,
		search: "?" + params.toString(),
	})
}

const toggleChart = (props, isMobile, dispatch) => {
	const params = new URLSearchParams(props.location.search)
	let viewParam = params.get("view")
	if (viewParam) {
		viewParam = viewParam.split(",")
		const isOpen = viewParam.includes("chart")
		if (isOpen) {
			if (viewParam.length > 1) {
				viewParam = viewParam.filter((view) => view !== "chart")
			} else {
				viewParam = ["layout"]
			}
		} else {
			if (isMobile) {
				viewParam = ["chart"]
			} else {
				viewParam.push("chart")
			}
		}
		dispatch({
			type: actionTypes.SET_SITE_VIEW,
			view: viewParam,
		})
		params.set("view", viewParam.join(","))
		props.history.push({
			pathname: props.location.pathname,
			search: "?" + params.toString(),
		})
	}
}

const downloadOfflineGui = () => {
	const url = "https://n9fvexcp0f.execute-api.us-east-1.amazonaws.com/staging"
	const file = "Offline_GUI.zip" // TODO make this reactive to user permissions and search for different file names
	const idToken = api.idToken
	const res = request.post(url).set({ Authorization: idToken }).send({ file: file })
	res.then((response) => {
		let a = document.createElement("a")
		a.href = response.body["body"]
		a.click()
	})
	res.catch((error) => alert(error))
}

// noinspection JSUnusedGlobalSymbols
const mapDispatchToProps = (dispatch, props) => ({
	setDrawerIsOpen: (isOpen) => dispatch(setDrawerIsOpen(isOpen)),
	openSearch: () => openSearch(props),
	toggleChart: (isMobile) => toggleChart(props, isMobile, dispatch),
	downloadOfflineGui: () => downloadOfflineGui(),
})

export default compose(withRouter, connect(mapStateToProps, mapDispatchToProps))(AppBar)
